'use client'
import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message'
import { IconCheck } from '@tabler/icons-react'
import classNames from 'classnames'
import React, { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { FieldErrors, FieldValues } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage'

interface CheckboxProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  checked: boolean
  onToggleValue: (value: boolean) => void
  label: ReactNode
  name: string
  errors?: FieldErrors<FieldValues>
  containerClassName?: string
}

const Checkbox: React.FC<CheckboxProps> = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const { errors, name, onToggleValue, label, containerClassName } = props
  const [checked, setChecked] = useState<boolean>(props.checked || false)

  function handleClick() {
    onToggleValue(!checked)
  }
  useEffect(() => {
    setChecked(props.checked)
  }, [props.checked])

  const inputRef = useRef<HTMLInputElement>(null)

  useImperativeHandle(ref, () => inputRef.current!)
  return (
    <div className={containerClassName}>
      <label className="flex flex-row gap-3 mb-5 items-center select-none cursor-pointer">
        {/* sr-only statt hidden: display:none nimmt das Feld aus Tabreihenfolge und
            Accessibility-Baum. Ohne name/id war es ausserdem weder per Tastatur
            erreichbar noch als Formularelement adressierbar (Fund aus dem E2E-Test). */}
        <input type="checkbox" id={name} name={name} ref={inputRef} checked={checked} onChange={handleClick} className="peer sr-only" />
        <div className={'w-5 h-5 flex items-center justify-center border-2 border-white rounded-sm peer-focus-visible:ring-2 peer-focus-visible:ring-accent peer-focus-visible:ring-offset-1'}>
          {checked && <IconCheck stroke={4} className="text-white w-[0.6rem]" />}
        </div>
        <div className={classNames('w-full')}>{label}</div>
      </label>
      {errors && name && <HookFormErrorMessage errors={errors} name={name} render={({ message }) => <ErrorMessage message={message} />} />}
    </div>
  )
})
Checkbox.displayName = 'Checkbox'

export default Checkbox
